import { render, staticRenderFns } from "./form-wrapper.vue?vue&type=template&id=80737134"
import script from "./form-wrapper.vue?vue&type=script&lang=js"
export * from "./form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80737134')) {
      api.createRecord('80737134', component.options)
    } else {
      api.reload('80737134', component.options)
    }
    module.hot.accept("./form-wrapper.vue?vue&type=template&id=80737134", function () {
      api.rerender('80737134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list-create/form-wrapper.vue"
export default component.exports